export default __webpack_public_path__ + "static/media/EDBBA996-8CB3-403E-8CCA-69CC5023720E.de07f320.jpeg";